import React from 'react';
import DataTable from '../DataTable/DataTable';
import CardPresenterGeneral from './CardPresenterGeneral';

export default class CardPresenterWorkspace extends React.Component{
  constructor(props){
    super(props)
  };

  render(){
    return(
      <div className="tab-content">
        {
          this.props.activeTab === 'paymentLogs' 
          ? 
          <DataTable 
            endpoint={this.props.payment_logs_path}
            no_data_text={I18n.t('none')}
            currency_unit={I18n.t('number.currency.format.unit')}
            delimiter={I18n.t('number.currency.format.delimiter')}
            separator={I18n.t('number.currency.format.separator')}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
          /> 
          : 
          <CardPresenterGeneral {...this.props} />}
      </div>
    );
  };
};